export default function Footer() {
  return (
    <footer className="bg-[#C5A059] relative">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-12 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-[30px] lg:gap-12">
          <div className="text-center lg:text-left">
            <img 
              src="https://static.readdy.ai/image/f7081275c8c5ad77b7068ab2b9330b46/2a07c29672384106c5a8c41b0fb0a062.png" 
              alt="Vitta Prime Grass" 
              className="h-14 lg:h-16 w-auto object-contain mb-4 lg:mb-6 mx-auto lg:mx-0"
              translate="no"
            />
            <p className="font-montserrat font-light text-white/90 text-sm leading-relaxed mb-4 lg:mb-6">
              Engenharia italiana e paisagismo de alto padrão para projetos exclusivos
            </p>
            <div className="flex items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://wa.me/5518996901341"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center hover:bg-white hover:rotate-[360deg] transition-all duration-500 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-white text-xl"></i>
              </a>
              <a
                href="https://instagram.com/vittaprimegrass"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center hover:bg-white hover:rotate-[360deg] transition-all duration-500 cursor-pointer"
              >
                <i className="ri-instagram-line text-white text-xl"></i>
              </a>
            </div>
          </div>

          <div className="text-center lg:text-left">
            <h3 className="font-montserrat font-semibold text-white text-base uppercase mb-4 lg:mb-6">Serviços</h3>
            <ul className="space-y-3 lg:space-y-4">
              <li>
                <a href="#servicos" className="font-montserrat text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Paisagismo Decorativo
                </a>
              </li>
              <li>
                <a href="#servicos" className="font-montserrat text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Campos Esportivos
                </a>
              </li>
              <li>
                <a href="#servicos" className="font-montserrat text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Quadras Poliesportivas
                </a>
              </li>
              <li>
                <a href="#limonta" className="font-montserrat text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  <span translate="no" className="notranslate">Tecnologia Limonta</span>
                </a>
              </li>
            </ul>
          </div>

          <div className="text-center lg:text-left">
            <h3 className="font-montserrat font-semibold text-white text-base uppercase mb-4 lg:mb-6">Empresa</h3>
            <ul className="space-y-3 lg:space-y-4">
              <li>
                <a href="#sobre" className="font-montserrat text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Sobre Nós
                </a>
              </li>
              <li>
                <a href="#sobre" className="font-montserrat text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Nossos Valores
                </a>
              </li>
              <li>
                <a href="#limonta" className="font-montserrat text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  <span translate="no" className="notranslate">Parceiro Limonta</span>
                </a>
              </li>
              <li>
                <a href="#contato" className="font-montserrat text-white/90 text-sm hover:text-white transition-colors cursor-pointer">
                  Contato
                </a>
              </li>
            </ul>
          </div>

          <div className="text-center lg:text-left">
            <h3 className="font-montserrat font-semibold text-white text-base uppercase mb-4 lg:mb-6">Contato</h3>
            <ul className="space-y-3 lg:space-y-4">
              <li className="flex items-start gap-3 justify-center lg:justify-start">
                <i className="ri-phone-line text-white text-lg mt-0.5"></i>
                <span className="font-montserrat text-white/90 text-sm">(18) 99690-1341</span>
              </li>
              <li className="flex items-start gap-3 justify-center lg:justify-start">
                <i className="ri-mail-line text-white text-lg mt-0.5"></i>
                <span className="font-montserrat text-white/90 text-sm break-all lg:break-normal">contato@vittaprimegrass.com.br</span>
              </li>
              <li className="flex items-start gap-3 justify-center lg:justify-start">
                <i className="ri-map-pin-line text-white text-lg mt-0.5"></i>
                <span className="font-montserrat text-white/90 text-sm">São Paulo, Brasil</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="relative bg-[#1B4D3E] py-6 lg:h-20">
        <div className="hidden lg:flex absolute inset-0 items-center justify-center">
          <span className="font-cinzel font-bold text-[#C5A059]/30 text-5xl tracking-[8px]"><span translate="no" className="notranslate">VITTA PRIME GRASS</span></span>
        </div>
        <div className="flex flex-col items-center gap-2 lg:absolute lg:bottom-4 lg:right-8 px-5">
          <span className="lg:hidden font-cinzel font-bold text-[#C5A059]/30 text-xl tracking-[4px]"><span translate="no" className="notranslate">VITTA PRIME GRASS</span></span>
          <p className="font-montserrat text-white/50 text-xs text-center">
            © 2025 <span translate="no" className="notranslate">Vitta Prime Grass</span>. Todos os direitos reservados. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </div>
    </footer>
  );
}